import { render } from "./BenchmarkManagerGroups.vue?vue&type=template&id=5034cd7c"
import script from "./BenchmarkManagerGroups.vue?vue&type=script&lang=js"
export * from "./BenchmarkManagerGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__